<ng-template #inputError let-error>
  <ng-container *ngIf="dirty && error !== null">
    <mat-error>
      {{ error }}
    </mat-error>
  </ng-container>
</ng-template>

<!-- <ng-template #episodeDynamicFields>
  <ng-container
    *ngIf="viewData.contentInformation.type === EpisodeInformationType.Sport"
  >
    <div class="row">
      <div class="col-lg-12">
        <mat-form-field appearance="fill">
          <mat-label>League</mat-label>
          <input
            matInput
            data-testid="epg-episode-details-league-input"
            placeholder="League"
            (ngModelChange)="onViewDataChange()"
            [(ngModel)]="viewData.contentInformation.league"
            type="text"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <mat-form-field appearance="fill">
          <mat-label>Season number</mat-label>
          <input
            matInput
            data-testid="epg-episode-season-number-input"
            placeholder="Season number"
            (ngModelChange)="onViewDataChange()"
            [(ngModel)]="viewData.contentInformation.season"
            type="number"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <mat-form-field appearance="fill">
          <mat-label>Location</mat-label>
          <input
            matInput
            placeholder="Location"
            data-testid="epg-episode-location-input"
            (ngModelChange)="onViewDataChange()"
            [(ngModel)]="viewData.contentInformation.location"
            type="text"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div
        class="col-lg-6"
        *ngFor="let team of viewData.contentInformation.teams; let i = index"
      >
        <mat-form-field appearance="fill">
          <mat-label>Name {{ alphabet[i] }}</mat-label>
          <input
            matInput
            placeholder="Name"
            data-testid="epg-episode-team-name-input"
            (ngModelChange)="onViewDataChange()"
            [(ngModel)]="team.name"
            type="text"
          />
        </mat-form-field>
      </div>
    </div>
  </ng-container>
  <ng-container
    *ngIf="viewData.contentInformation.type === EpisodeInformationType.Show"
  >
    <div class="row">
      <div class="col-lg-12">
        <mat-form-field appearance="fill">
          <mat-label>Episode number</mat-label>
          <input
            matInput
            placeholder="Episode number"
            data-testid="epg-episode-episode-number-input"
            (ngModelChange)="onViewDataChange()"
            [(ngModel)]="viewData.contentInformation.episode"
            type="number"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <mat-form-field appearance="fill">
          <mat-label>Season number</mat-label>
          <input
            matInput
            placeholder="Season number"
            data-testid="epg-episode-season-number-input"
            (ngModelChange)="onViewDataChange()"
            [(ngModel)]="viewData.contentInformation.season"
            type="number"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <mat-form-field appearance="fill">
          <mat-label>Cast</mat-label>
          <input
            matInput
            placeholder="Cast"
            data-testid="epg-episode-cast-input"
            (ngModelChange)="onViewDataChange()"
            [(ngModel)]="viewData.contentInformation.cast"
            type="text"
          />
        </mat-form-field>
      </div>
    </div>
  </ng-container>
  <ng-container
    *ngIf="viewData.contentInformation.type === EpisodeInformationType.Movie"
  >
    <div class="row">
      <div class="col-lg-12">
        <mat-form-field appearance="fill">
          <mat-label>Cast</mat-label>
          <input
            matInput
            placeholder="Cast"
            data-testid="epg-episode-cast-input"
            (ngModelChange)="onViewDataChange()"
            [(ngModel)]="viewData.contentInformation.cast"
            type="text"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <mat-form-field appearance="fill">
          <mat-label>Year</mat-label>
          <input
            matInput
            placeholder="Year"
            data-testid="epg-episode-year-input"
            (ngModelChange)="onViewDataChange()"
            [(ngModel)]="viewData.contentInformation.year"
            type="number"
          />
        </mat-form-field>
      </div>
    </div>
  </ng-container>
  <ng-container
    *ngIf="viewData.contentInformation.type === EpisodeInformationType.News"
  >
    <div class="row">
      <div class="col-lg-12">
        <mat-form-field appearance="fill">
          <mat-label>Show Host</mat-label>
          <input
            matInput
            placeholder="Show Host"
            data-testid="epg-episode-host-input"
            (ngModelChange)="onViewDataChange()"
            [(ngModel)]="viewData.contentInformation.host"
            type="text"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <mat-form-field appearance="fill">
          <mat-label>Season number</mat-label>
          <input
            matInput
            placeholder="Season number"
            data-testid="epg-episode-season-input"
            (ngModelChange)="onViewDataChange()"
            [(ngModel)]="viewData.contentInformation.season"
            type="number"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <mat-form-field appearance="fill">
          <mat-label>Episode number</mat-label>
          <input
            matInput
            placeholder="Episode number"
            data-testid="epg-episode-year-input"
            (ngModelChange)="onViewDataChange()"
            [(ngModel)]="viewData.contentInformation.episode"
            type="number"
          />
        </mat-form-field>
      </div>
    </div>
  </ng-container>
</ng-template> -->

<div class="episode-details">
  <div class="row">
    <div class="col-lg-12" *ngIf="isUpdatingViewData">
      <div
        class="w-100 h-100 flex-column d-flex justify-content-center align-items-center"
      >
        <mat-spinner class="mb-3" [diameter]="40"></mat-spinner>
        Processing...
      </div>
    </div>
    <div
      class="col-lg-12 p-0"
      [ngStyle]="{ opacity: isUpdatingViewData ? 0 : 1 }"
    >
      <div class="row tabgroup-container">
        <mat-tab-group
          mat-stretch-tabs
          [animationDuration]="tabGroupAnimationDuration"
          [selectedIndex]="currentTab"
          (selectedIndexChange)="onTabChanged($event)"
        >
          <mat-tab>
            <ng-template mat-tab-label>
              <span data-test-id="management-dialog-tab-general">
                General
              </span>
            </ng-template>
            <app-episode-general-tab
              [data]="data"
              (viewDataUpdateEvent)="updateViewDataFromChilds($event)"
              (errorUpdateEvent)="updateErrorFromChilds($event)"
              (thumbnailTitleUpdateEvent)="onThumbnailTitleUpdateEvent($event)"
              (thumbnailCardUpdateEvent)="onThumbnailCardUpdateEvent($event)"
              [showErrors]="showGeneralErrrors"
            ></app-episode-general-tab>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <span data-test-id="management-dialog-tab-general"> Time </span>
            </ng-template>
            <app-episode-time-tab
              [data]="data"
              (viewDataUpdateEvent)="updateViewDataFromChilds($event)"
              (errorUpdateEvent)="updateErrorFromChilds($event)"
              [showErrors]="showGeneralErrrors"
            ></app-episode-time-tab>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</div>
